// ServiceProvider enum to match the Go version
export enum ServiceProvider {
  FINCH = 'FINCH',
  ZAPIER = 'ZAPIER',
  // Add other providers as needed
}

// ServiceProvider represents the external service (Finch, Zapier, etc.)
export enum ServiceProviderStatus {
  ServiceProviderStatusActive = 'active',
  ServiceProviderStatusReauthRequired = 'reauth_required',
  ServiceProviderStatusInactive = 'inactive',
  ServiceProviderStatusPending = 'pending',
  ServiceProviderStatusDisabled = 'disabled',
  ServiceProviderStatusDeleted = 'deleted',
  ServiceProviderStatusArchived = 'archived',
  ServiceProviderStatusNone = 'none',
}
// CredentialDTO interface that matches the Go server-side structure
export interface CredentialsDTO {
  id?: string // Optional UUID as string
  rootOrganizationId: string // UUID as string
  provider: ServiceProvider // Service provider enum
  credentialName: string // Name of the credential
  credentialData: Record<string, any> // Raw credential data (will be encrypted)
  metadata?: Record<string, any> // Optional metadata
  status: string // Status of the credential
  expiresAt?: string // Optional ISO date string
}

// CredentialDTO interface that matches the Go server-side structure
export interface CredentialsResponse {
  id?: string // Optional UUID as string
  rootOrganizationId: string // UUID as string
  provider: ServiceProvider // Service provider enum
  credentialName: string // Name of the credential
  metadata?: Record<string, any> // Optional metadata
  status: string // Status of the credential
  expiresAt?: string // Optional ISO date string
}
